var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.108 20H4C3.73478 20 3.48043 20.1054 3.29289 20.2929C3.10536 20.4804 3 20.7348 3 21C3 21.2652 3.10536 21.5196 3.29289 21.7071C3.48043 21.8946 3.73478 22 4 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21C21 20.7348 20.8946 20.4804 20.7071 20.2929C20.5196 20.1054 20.2652 20 20 20H17.892C17.645 17.226 16.821 12.39 14.066 11C16.63 9.577 17.519 6.19 17.83 4H20C20.2652 4 20.5196 3.89464 20.7071 3.70711C20.8946 3.51957 21 3.26522 21 3C21 2.73478 20.8946 2.48043 20.7071 2.29289C20.5196 2.10536 20.2652 2 20 2H4C3.73478 2 3.48043 2.10536 3.29289 2.29289C3.10536 2.48043 3 2.73478 3 3C3 3.26522 3.10536 3.51957 3.29289 3.70711C3.48043 3.89464 3.73478 4 4 4H6.17C6.481 6.19 7.37 9.577 9.934 11C7.179 12.39 6.355 17.226 6.108 20ZM9 16.6C9 15.4 12 13 12 13C12 13 15 15.4 15 16.6V20H9V16.6Z",
    fill: "#FEE069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.7f0b609b946a412b80787b77abfb3934.svg";
export { ForwardRef as ReactComponent };